import React from "react";
import { Container, Row } from "react-bootstrap";
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import {
    MdWork,
    MdSchool,
    MdStar,
    MdOutlineReceipt,
    MdArrowDownward,
    MdVideogameAsset,
    MdSmartToy,
    MdMenuBook,
  } from "react-icons/md";

function Timeline() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
        <VerticalTimeline>
        <VerticalTimelineElement
    iconStyle={{ background: 'rgb(12, 5, 19)', color: '#fff' }}
    icon={<MdArrowDownward />}
  />

 
<VerticalTimelineElement
    className="vertical-timeline-element--work"
    contentStyle={{ background: 'rgb(12, 5, 19)', color: '#fff' }}
    contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
    date="January 2026 - Present"
    dateClassName="date-color-override"
    iconStyle={{ background: 'rgb(12, 5, 19)', color: '#fff' }}
    icon={<MdSmartToy />}
  >
    <h3 className="vertical-timeline-element-title">AI Solutions Enthusiast</h3>
    <h4 className="vertical-timeline-element-subtitle">Acumen Technology</h4>
    <p align="left">
      <ul>
        <li>Began building internal AI agents and automation tools using Microsoft Copilot Studio and external AI platforms.</li>
        <li>Designed AI-assisted workflows to reduce manual overhead across project coordination, reporting, and client communication.</li>
        <li>Developed and deployed agents capable of generating project summaries, milestone suggestions, and automated portfolio briefings.</li>
        <li>Actively expanding the AI toolset to address evolving team workflow needs.</li>
      </ul>
    </p>
  </VerticalTimelineElement>

<VerticalTimelineElement
    className="vertical-timeline-element--work"
    contentStyle={{ background: 'rgb(12, 5, 19)', color: '#fff' }}
    contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
    date="June 2024 - Present"
    dateClassName="date-color-override"
    iconStyle={{ background: 'rgb(12, 5, 19)', color: '#fff' }}
    icon={<MdMenuBook />}
  >
    <h3 className="vertical-timeline-element-title">Knowledge Manager</h3>
    <h4 className="vertical-timeline-element-subtitle">Acumen Technology - In addition to Project Coordinator</h4>
    <p align="left">
      <ul>
        <li>Assumed ownership of internal knowledge documentation alongside ongoing project coordination responsibilities.</li>
        <li>Audited and restructured internal documentation for consistency, accuracy, and accessibility.</li>
        <li>Established templates and contribution standards to ensure documentation remains current.</li>
        <li>Serves as the internal authority for process documentation and knowledge governance.</li>
      </ul>
    </p>
  </VerticalTimelineElement>

  <VerticalTimelineElement
    className="vertical-timeline-element--education"
    date="November 2024"
    dateClassName= "date-color-override"
    iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
    icon={<MdOutlineReceipt />}
  >
    <h3 className="vertical-timeline-element-title">PMI-ACP (Agile Certified Practitioner)</h3>
    <h4 className="vertical-timeline-element-subtitle">Certification</h4>
  </VerticalTimelineElement>

<VerticalTimelineElement
    className="vertical-timeline-element--education"
    date="May 2024"
    dateClassName= "date-color-override"
    iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
    icon={<MdOutlineReceipt />}
  >
    <h3 className="vertical-timeline-element-title">PMI-CAPM (Certified Associate in Project Management)</h3>
    <h4 className="vertical-timeline-element-subtitle">Certification</h4>
  </VerticalTimelineElement>

<VerticalTimelineElement
    className="vertical-timeline-element--work"
    contentStyle={{ background: 'rgb(12, 5, 19)', color: '#fff' }}
    contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
    date= "January 2023 - Present" 
    dateClassName= "date-color-override"
    iconStyle={{ background: 'rgb(12, 5, 19)', color: '#fff' }}
    icon={<MdWork />}
  >
    <h3 className="vertical-timeline-element-title">Project Coordinator</h3>
    <h4 className="vertical-timeline-element-subtitle">Acumen Technology</h4>
    <p align="left">
        <ul>
            <li>Championed hybrid project methodology, combining PMI process groups with Agile ceremonies to fit client needs and urgency.</li>
            <li>Led 100+ client infrastructure projects, including cloud migrations, server upgrades, and Microsoft 365 deployments—achieved 99% on-time delivery.</li>
            <li>Analyzed project timelines and processes to reduce new client onboarding cycle by 50% (from 90 to 45 days) through standardization of workflows and Agile sprint cycles.</li>
            <li>Collaborated with project team members to streamline backlog resolution—cleared 80+ aging projects in 3 months.</li>
            <li>Headlined the effort to standardize process and configuration documentation.</li>
            </ul>

    </p>
  </VerticalTimelineElement>

<VerticalTimelineElement
    className="vertical-timeline-element--education"
    date="November 2022"
    dateClassName= "date-color-override"
    iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
    icon={<MdOutlineReceipt />}
  >
    <h3 className="vertical-timeline-element-title">Microsoft 365 Certified: Enterprise Administrator Expert</h3>
    <h4 className="vertical-timeline-element-subtitle">Certification</h4>
  </VerticalTimelineElement>

<VerticalTimelineElement
    className="vertical-timeline-element--education"
    date="November 2022"
    dateClassName= "date-color-override"
    iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
    icon={<MdOutlineReceipt />}
  >
    <h3 className="vertical-timeline-element-title">Microsoft 365 Mobility and Security (MS-101)</h3>
    <h4 className="vertical-timeline-element-subtitle">Exam</h4>
  </VerticalTimelineElement>

<VerticalTimelineElement
    className="vertical-timeline-element--education"
    date="November 2022"
    dateClassName= "date-color-override"
    iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
    icon={<MdOutlineReceipt />}
  >
    <h3 className="vertical-timeline-element-title">Microsoft 365 Identity and Services (MS-100)</h3>
    <h4 className="vertical-timeline-element-subtitle">Exam</h4>
  </VerticalTimelineElement>




      <VerticalTimelineElement
    className="vertical-timeline-element--education"
    date="August 2022"
    dateClassName= "date-color-override"
    iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
    icon={<MdOutlineReceipt />}
  >
    <h3 className="vertical-timeline-element-title">Microsoft 365 Security Administrator Associate (MS-500)</h3>
    <h4 className="vertical-timeline-element-subtitle">Certification</h4>
  </VerticalTimelineElement>


    <VerticalTimelineElement
    className="vertical-timeline-element--education"
    date="August 2022"
    dateClassName= "date-color-override"
    iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
    icon={<MdOutlineReceipt />}
  >
    <h3 className="vertical-timeline-element-title">Microsoft 365 Fundamentals (MS-900)</h3>
    <h4 className="vertical-timeline-element-subtitle">Certification</h4>
  </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--work"
    contentStyle={{ background: 'rgb(12, 5, 19)', color: '#fff' }}
    contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
    date= "July 2021 - December 2021" 
    dateClassName= "date-color-override"
    iconStyle={{ background: 'rgb(12, 5, 19)', color: '#fff' }}
    icon={<MdWork />}
  >
    <h3 className="vertical-timeline-element-title">Service Desk Analyst III</h3>
    <h4 className="vertical-timeline-element-subtitle">Acumen Technology</h4>
    <p align="left">
        <ul>
            <li>Developed PowerShell-based Active Directory toolkit, reducing user creation time by 60%</li>
            <li>Managed complex IT infrastructure including servers, firewalls, VPNs, and line-of-business applications across dozens of clients and hundreds of endpoints.</li>
            <li>Implemented a standardized documentation system for the Service Desk, streamlining processes and improving knowledge sharing.</li>
            <li>Provided mentorship to junior analysts, fostering a collaborative environment that enhanced team performance and service delivery.</li>
            </ul>

    </p>
  </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--work"
    dateClassName= "date-color-override"
    date="June 2022"
    iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
    icon={<MdWork />}
  >
    <h3 className="vertical-timeline-element-title">Process & Procedures Analyst</h3>
    <h4 className="vertical-timeline-element-subtitle">GrubRunner - Monthly Contract</h4>
    <p align="left">
        <ul>
            <li>Developed and implemented comprehensive standard operating procedures and technical disaster recovery documents.</li>
            </ul>

    </p>
  </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--work"
    dateClassName= "date-color-override"
    date="January 2022 - April 2022"
    iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
    icon={<MdWork />}
  >
    <h3 className="vertical-timeline-element-title">Knowledge Base Administrator</h3>
    <h4 className="vertical-timeline-element-subtitle">Red Bull - Quarterly Contract</h4>
    <p align="left">
        <ul>
            <li>Analyzed user feedback to refine knowledge management processes, resulting in noticeable gains in user satisfaction and
            engagement.</li>
            <li>Implemented a tagging system for documents, streamlining search functions and significantly reducing time spent on
            information retrieval.</li>
            <li>Provided training sessions for staff on knowledge management tools, empowering employees and enhancing their ability to
            contribute effectively.</li>
            </ul>

    </p>
  </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--education"
    date="August 2021"
    dateClassName= "date-color-override"
    iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
    icon={<MdOutlineReceipt />}
  >
    <h3 className="vertical-timeline-element-title">Microsoft Azure Fundamentals (AZ-900)</h3>
    <h4 className="vertical-timeline-element-subtitle">Certification</h4>
  </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--education"
    date="July 2021"
    dateClassName= "date-color-override"
    iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
    icon={<MdOutlineReceipt />}
  >
    <h3 className="vertical-timeline-element-title">CompTia A+</h3>
    <h4 className="vertical-timeline-element-subtitle">Certification</h4>
  </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--education"
    date="August 2019 - May 2021"
    dateClassName= "date-color-override"
    iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
    icon={<MdSchool />}
  >
    <h3 className="vertical-timeline-element-title">Information Technology</h3>
    <h4 className="vertical-timeline-element-subtitle">Bachelor's Degree</h4>
    <p>
      Tennessee Technological University<br />
      3.84 GPA - Cum Laude
    </p>
  </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--work"
    dateClassName= "date-color-override"
    date="October 2020 - January 2021"
    iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
    icon={<MdWork />}
  >
    <h3 className="vertical-timeline-element-title">Technical Writer - Quarterly Contract</h3>
    <h4 className="vertical-timeline-element-subtitle">SimpleVoIP</h4>
    <p align="left">
        <ul>
            <li>Developed comprehensive knowledge base articles, enhancing user understanding and reducing support inquiries for
            SimpleVoIP's technical documentation.</li>
            </ul>

    </p>
  </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--education"
    date="March 2020"
    dateClassName= "date-color-override"
    iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
    icon={<MdOutlineReceipt />}
  >
    <h3 className="vertical-timeline-element-title">Help Desk Institute: CSR</h3>
    <h4 className="vertical-timeline-element-subtitle">Certification</h4>
  </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--work"
    dateClassName= "date-color-override"
    date="February 2019 - July 2021"
    iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
    icon={<MdWork />}
  >
    <h3 className="vertical-timeline-element-title">Service Desk Supervisor</h3>
    <h4 className="vertical-timeline-element-subtitle">Tennessee Technological University</h4>
    <p align="left">
        <ul>
            <li>Chaired the Policies & Procedures Committee, leading to a standardized approach for Change Management and IT processes.</li>
            <li>IManaged project communication strategies, leading to marked success during the ITSM platform implementation.</li>
            <li>Designed a comprehensive Knowledge Base and Service Catalog, facilitating user access to resources and streamlining
            support requests.</li>
            <li>Mentored a team of student employees, fostering a collaborative environment and enhancing their customer service skills.</li>
            </ul>

    </p>
  </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--education"
    date="March 2019"
    dateClassName= "date-color-override"
    iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
    icon={<MdOutlineReceipt />}
  >
    <h3 className="vertical-timeline-element-title">ITIL v3 Foundations</h3>
    <h4 className="vertical-timeline-element-subtitle">Certification</h4>
  </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--work"
    dateClassName= "date-color-override"
    date="June 2018 - February 2019"
    iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
    icon={<MdWork />}
  >
    <h3 className="vertical-timeline-element-title">Service Desk Analyst II</h3>
    <h4 className="vertical-timeline-element-subtitle">SAIC</h4>
    <p align="left">
        <ul>
            <li>Provided Tier 3 support for the Virginia IT Agency contract, ensuring efficient problem resolution and service delivery.</li>
            <li> Developed comprehensive technical documentation, facilitating knowledge transfer and compliance with ITIL best practices.</li>
            <li> Enhanced ServiceNow workflows to streamline incident management, resulting in faster resolution times and improved user
satisfaction.</li>
            </ul>

    </p>
  </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--work"
    dateClassName= "date-color-override"
    date="August 2017 - January 2018"
    iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
    icon={<MdVideogameAsset />}
  >
    <h3 className="vertical-timeline-element-title">Esports Manager</h3>
    <h4 className="vertical-timeline-element-subtitle">Team Aurora</h4>
    <p align="left">
        <ul>
            <li>Created recruitment process standards.</li>
            <li>Reached out and secured sponsorships.</li>
            <li>Created performance review standards.</li>
            <li>Organized skirmish and tournament matches.</li>
            </ul>

    </p>
  </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--work"
    dateClassName= "date-color-override"
    date="August 2015 - May 2018"
    iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
    icon={<MdWork />}
  >
    <h3 className="vertical-timeline-element-title">IT Support</h3>
    <h4 className="vertical-timeline-element-subtitle">McCoy Federal Credit Union</h4>
    <p align="left">
        <ul>
            <li>Managed IT services for over 300 endpoints, ensuring seamless network performance and high availability across multiple
            locations.</li>
            <li>Implemented proactive maintenance protocols, leading to a significant reduction in downtime and improving operational
            efficiency.</li>
            <li>Monitored system performance metrics to identify trends, facilitating targeted upgrades and minimizing service interruptions.</li>
            </ul>

    </p>
  </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--education"
    date="May 2013"
    dateClassName= "date-color-override"
    iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
    icon={<MdOutlineReceipt />}
  >
    <h3 className="vertical-timeline-element-title">CompTia A+</h3>
    <h4 className="vertical-timeline-element-subtitle">Certification</h4>
  </VerticalTimelineElement>
  <VerticalTimelineElement
    iconStyle={{ background: 'rgb(16, 204, 82)', color: '#fff' }}
    icon={<MdStar />}
  />
</VerticalTimeline>
        </Row>
      </Container>
    </Container>
  );
}
export default Timeline;
